
import { Component, Prop, Vue } from 'vue-property-decorator';
import { isUsableImageUrl } from '@/helpers/variantImage';

@Component({})
export default class CatalogProductTable extends Vue {
  /**
   * The usable-image rule, exposed so the template can call it. A Vue class
   * component cannot call a module function from a template unless it is a
   * class property — without this the v-if evaluates `undefined` as a
   * function and Vue warns at runtime while the build stays green.
   */
  private isUsableImageUrl = isUsableImageUrl;

  @Prop({ required: true }) public readonly items!: any[];
  @Prop({ required: true }) public readonly totalItems!: number;
  @Prop({ required: true }) public readonly loading!: boolean;
  @Prop({ required: true }) public readonly listItemsByVariant!: Record<number, { id: number; quantity: number }>;
  @Prop({ default: 'USD' }) public readonly currencyCode!: string;

  public pagination: any = { page: 1, itemsPerPage: 50 };

  public headers = [
    { text: '', value: 'image', sortable: false },
    { text: 'Product', value: 'productName' },
    { text: 'SKU', value: 'sku' },
    { text: 'Stock', value: 'currentStock' },
    { text: 'Cost', value: 'unitCost' },
    { text: '', value: 'action', sortable: false },
    { text: '', value: 'data-table-expand' },
  ];

  public isInList(variantId: number): boolean {
    return !!this.listItemsByVariant[variantId];
  }
  public listQuantity(variantId: number): number {
    return this.listItemsByVariant[variantId]?.quantity ?? 0;
  }
  public add(row: any): void {
    this.$emit('add', row);
  }
  public step(row: any, delta: number): void {
    this.$emit('step', { row, delta });
  }
  public formatCost(v: number): string { return `${this.currencyCode} ${Number(v).toFixed(2)}`; }
}
